












































































































import { Component, Vue, Provide, Mixins, Watch } from 'vue-property-decorator';
import MixinResults from '@/plugins/podolib/services/helper/mixins/results';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TStation } from '@/plugins/podolib/services/entities/EntityStations';
import { AnalysisType, AnalysisWalkingMode, StepType } from '@/components/analysis/steps/type/AnalysisStepType';

@Component({
  components: {
    ChartRawWalkingBanner: () => import('@/components/charts/walking/ChartRawWalkingBanner.vue'),
    ChartRawPhaseWalkStepsDegraded: () => import('@/components/charts/walking/ChartRawPhaseWalkStepsDegraded.vue'),
    ChartRawGaugeSections: () => import('@/components/charts/walking/ChartRawGaugeSections.vue'),
    ChartRawFootProgression: () => import('@/components/charts/walking/ChartRawFootProgression.vue'),
    PatientAcquisitionComments: () => import('@/components/patients/PatientAcquisitionComments.vue'),
    //
    ElementResultsTooltip: () => import('@/components/elements/ElementResultsTooltip.vue'),
    //
    DialogAcquisitionInProgress: () => import('@/components/dialogs/DialogAcquisitionInProgress.vue'),
    DialogStartAnalysisWithoutConnectedStation: () =>
      import('@/components/dialogs/DialogStartAnalysisWithoutConnectedStation.vue'),
    PatientAcquisitionDelete: () => import('@/components/patients/acquisition/PatientAcquisitionDelete.vue'),
  },
})
export default class PatientResultsWalkingDegraded extends Mixins(MixinResults) {
  @Provide() relativeValues: boolean = false;
  // Dialogs open values
  @Provide() acquisitionInProgressDialog = false;
  @Provide() noStationAvailableDialog = false;

  get startAcquisitionLinkLocked() {
    return this.$pdc.helper!.isDemo || !this.$pdc.entities!.stations.storedEntity.list.length;
  }
  // Has connected station ?
  get connectedStations() {
    return this.$pdc.analysis!.entityStations!.data.filter((x: TEntity<TStation>) => x.online).length;
  }

  goToAcquisition() {
    if (this.startAcquisitionLinkLocked) {
      this.$pdc.bus!.emit('equipments:get-kit:open');
    } else {
      if (this.$pdc.analysis!.manifestHasData) {
        this.acquisitionInProgressDialog = true;
      } else if (!this.connectedStations!) {
        this.noStationAvailableDialog = true;
      } else {
        // Analytics
        this.$pdc.analytics?.actions.trackSuccess('NewAnalysis Opened', {
          patientId: this.patient._id,
        });
        const degradedActivity: any = {
          type: {
            mode: AnalysisWalkingMode.Standard,
            type: AnalysisType.Walking,
          },
          conditions: this.acquisition.conditions,
          station: { stationId: this.acquisition.station },
          soles: this.acquisition.soles,
        };

        this.$router.push({
          path: '/analysis',
          query: {
            patientId: this.patient._id,
            degradedActivity,
          },
        });
      }
    }
  }

  openDeleteDialog() {
    (this.$refs.delete as any).open(this.patient, this.acquisition._id);
  }

  getCols(basicValue: number) {
    return this.compareAcquisition ? 12 : basicValue;
  }

  // Close dialogs
  closeAnalysisDialog() {
    this.acquisitionInProgressDialog = false;
  }
  closeNoStationDialog() {
    this.noStationAvailableDialog = false;
  }
}
